import React, { useEffect, useState } from 'react';

import clsx from 'clsx';

import type { ICommunitiesViewCommunity } from '../../../redux/api/communities/communities-api.types';
import Search from '../search/Search';
import { useStyles } from './CommunitiesList.styles';
import CommunitySmallItem from './community-small-item/CommunitySmallItem';

export interface ICommunitiesListSmallProps {
  communities: ICommunitiesViewCommunity[] | null | undefined;
  showSearch?: boolean;
}

export default function CommunitiesListSmall(
  props: ICommunitiesListSmallProps,
) {
  const { communities, showSearch = false } = props;
  const { classes } = useStyles();
  const [filterValue, setFilterValue] = useState<string>('');
  const [filteredCommunities, setFilteredCommunities] = useState<
    ICommunitiesViewCommunity[] | null
  >(communities);

  useEffect(() => {
    if (!communities) {
      setFilteredCommunities(null);
      return;
    }
    if (!filterValue) {
      setFilteredCommunities(communities);
    } else {
      const valueLowerCase = filterValue.toLowerCase();
      setFilteredCommunities(
        communities.filter(
          (c) => c.title?.toLowerCase().indexOf(valueLowerCase) !== -1,
        ),
      );
    }
  }, [filterValue, communities]);

  return (
    <div className={clsx(classes.communitiesListWrapper, classes.narrowScreen)}>
      {showSearch && (
        <Search
          fullWidth
          value={filterValue}
          onChange={setFilterValue}
          className={classes.communitiesListSearch}
        />
      )}
      {filteredCommunities?.map((c) => (
        <React.Fragment key={c.id}>
          <CommunitySmallItem community={c} />
        </React.Fragment>
      ))}
    </div>
  );
}
